import { render, staticRenderFns } from "./PapercleanConfigurazioneGruppiListPage.vue?vue&type=template&id=0628810d&scoped=true"
import script from "./PapercleanConfigurazioneGruppiListPage.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneGruppiListPage.vue?vue&type=script&lang=js"
import style0 from "./PapercleanConfigurazioneGruppiListPage.vue?vue&type=style&index=0&id=0628810d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628810d",
  null
  
)

export default component.exports